import { TermsAndPrivacyIndex, TermOrPrivacy } from '../types'

const ContactingUs = (
  <>
    <p>
      หากคุณต้องการสอบถามข้อมูลเกี่ยวกับนโยบายความเป็นส่วนตัวฉบับนี้
      รวมถึงการขอใช้สิทธิต่าง ๆ
      คุณสามารถติดต่อเราหรือเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของเราได้ ดังนี้
    </p>
    <p>
      <strong css={{ fontSize: '20px' }}>บริษัท เอ็นเดต้าธอธ จำกัด</strong>
      <br />
      1778 อาคารซัมเมอร์ฮับ ออฟฟิศ ชั้นที่ 6 ถนนสุขุมวิท แขวงพระโขนง เขตคลองเตย
      กรุงเทพมหานคร
      <br />
      <br />
      อีเมล: <a href="mailto:dpo@ndatathoth.com">dpo@ndatathoth.com </a>
      <br />
      โทรศัพท์: <a href="tel:020245560">02-024-5560</a>
    </p>
  </>
)

export const termsAndPrivacyIndexes: Record<
  TermOrPrivacy,
  TermsAndPrivacyIndex
> = {
  terms: {
    title: 'ข้อกำหนดและเงื่อนไขการใช้งาน',
    linkTo: '/terms-of-use',
    subMenus: [
      {
        title: 'บัญชีผู้ใช้และสมาชิก',
        scrollTo: 'terms-accounts-and-membership',
        content: (
          <p>
            หากท่านได้ทำการสร้างบัญชีผู้ใช้บนเว็บไซต์ Consent Wow
            ท่านมีหน้าที่ในการรักษาความปลอดภัยของบัญชีของท่านและท่านต้องรับผิดชอบต่อกิจกรรมทั้งหมดที่เกิดขึ้นภายใต้การใช้งานบัญชีหรือการดำเนินการอื่นใดที่เกี่ยวข้องกับบัญชีนั้น
            เราอาจจะ (ซึ่งเราไม่มีหน้าที่)
            มีการสังเกตการณ์และตรวจสอบบัญชีใหม่ก่อนที่ท่านจะลงชื่อเข้าใช้และใช้บริการของเรา
            การให้ข้อมูลติดต่อที่เป็นเท็จไม่ว่าประเภทใดก็ตามอาจส่งผลให้บัญชีของท่านถูกยุติการใช้งาน
            ท่านต้องแจ้งให้เราทราบทันทีเมื่อบัญชีของท่านถูกนำไปใช้โดยไม่ได้รับอนุญาตหรือเมื่อมีการละเมิดความปลอดภัยอื่น
            ๆ ทางเราจะไม่ขอรับผิดชอบต่อความเสียหายใด ๆ
            ที่เกิดขึ้นจากการกระทำหรือการละเว้นการกระทำของท่าน เราอาจทำการระงับ
            ปิดการใช้งาน หรือลบบัญชีผู้ใช้ของท่าน (หรืออย่างใดอย่างหนึ่ง)
            หากเราพิจารณาว่าท่านได้ละเมิดข้อกำหนดใด ๆ
            ของข้อตกลงนี้หรือการกระทำของท่านมีแนวโน้มที่จะทำลายชื่อเสียงและค่าความนิยมของเรา
            หากเราลบบัญชีของท่านด้วยเหตุผลข้างต้น
            ท่านจะไม่สามารถลงทะเบียนใหม่เพื่อใช้บริการของเราได้
            โดยเราอาจทำการปิดกั้นที่อยู่อีเมลและที่อยู่อินเทอร์เน็ตโปรโตคอลของท่านเพื่อป้องกันการลงทะเบียนอีกครั้ง
          </p>
        ),
      },
      {
        title: 'การใช้งาน',
        scrollTo: 'terms-usage',
        content: (
          <p>
            Consent Wow
            เป็นบริการที่มีวัตถุประสงค์เพื่อช่วยเหลือท่านในการบริหารและจัดการการขอความยินยอมจากเจ้าของข้อมูลที่ท่านมีการเก็บรวบรวมข้อมูลส่วนบุคคล
          </p>
        ),
      },
      {
        title: 'เนื้อหาของผู้ใช้งาน',
        scrollTo: 'terms-user-content',
        content: (
          <p>
            เราไม่ได้เป็นเจ้าของข้อมูลหรือเนื้อหาใด ๆ (“เนื้อหา”)
            ที่ท่านได้ให้ไว้บนเว็บไซต์ Consent Wow เพื่อการใช้งานใช้บริการ
            ท่านจะต้องรับผิดชอบต่อความถูกต้อง คุณภาพ ความสมบูรณ์
            ความถูกต้องตามกฎหมาย ความน่าเชื่อถือ
            ความเหมาะสมและความเป็นเจ้าของทรัพย์สินทางปัญญาหรือสิทธิในการใช้เนื้อหาที่นำส่งทั้งหมดแต่เพียงผู้เดียว
            เราอาจสังเกตการณ์และตรวจสอบเนื้อหาบนเว็บไซต์ที่ท่านนำส่งหรือสร้างขึ้นจากการบริการโดยตัวท่าน
            การใช้งานเว็บไซต์ Consent Wow โดยท่าน ไม่ถือเป็นการอนุญาตเราในการใช้
            ทำซ้ำ ดัดแปลง แก้ไข เผยแพร่
            หรือแจกจ่ายเนื้อหาที่ท่านสร้างขึ้นหรือจัดเก็บไว้ในบัญชีผู้ใช้ของท่านเพื่อการค้า
            การตลาดหรือวัตถุประสงค์อื่นใดที่มีคล้ายกันเว้นแต่ท่านจะให้การอนุญาตแก่เราเป็นการเฉพาะ
            อย่างไรก็ตาม ท่านให้สิทธิแก่เราในการเข้าถึง คัดลอก แจกจ่าย จัดเก็บ
            ส่ง
            จัดรูปแบบใหม่และแสดงเนื้อหาของบัญชีผู้ใช้ของท่านตามที่กำหนดไว้สำหรับวัตถุประสงค์ในการให้บริการแก่ท่านเท่านั้น
            เราขอสงวนสิทธิในการปฏิเสธหรือลบเนื้อหาใด ๆ ที่ละเมิดนโยบายของเรา
            ไม่เหมาะสม
            หรือเป็นอันตรายในทางใดทางหนึ่งต่อข้อกำหนดและเงื่อนไขตามดุลยพินิจของเราโดยไม่เป็นการจำกัดการรับรองและการรับประกันที่เราได้กำหนดไว้
          </p>
        ),
      },
      {
        title: 'การเรียกเก็บเงินและชำระเงิน',
        scrollTo: 'terms-billing-and-payments',
        content: (
          <>
            <p>
              ท่านจะต้องชำระค่าธรรมเนียมหรือเงินเพิ่มของบัญชีการใช้งานของท่านตามค่าธรรมเนียม
              เงินเพิ่ม และข้อกำหนดเรื่องการเรียกเก็บเงินเมื่อถึงครบกำหนดชำระ
              ในกรณีที่มีการนำเสนอบริการแบบทดลองใช้งานโดยไม่เสียค่าใช้จ่าย
              ท่านอาจต้องชำระเงินหลังจากที่ช่วงทดลองใช้โดยไม่เสียค่าใช้จ่ายได้สิ้นสุดลง
              ไม่ใช่เมื่อท่านใส่รายละเอียดในการเรียกเก็บเงินของท่าน
              (ซึ่งอาจจำเป็นต้องใส่ก่อนที่จะเริ่มช่วงทดลองโดยไม่เสียค่าใช้จ่าย)
              หากการต่ออายุการใช้งานโดยอัตโนมัติมีการเปิดใช้งานสำหรับการบริการที่ท่านได้เลือกใช้
              ท่านจะถูกเรียกเก็บเงินโดยอัตโนมัติตามเงื่อนไขที่ท่านได้เลือกไว้จนกว่าท่านจะยกเลิกบริการกับเรา
              หากเรามีความเห็นว่าการทำธุรกรรมของท่านถือเป็นการทำธุรกรรมที่มีความเสี่ยงสูง
              เราจะขอให้ท่านส่งสำเนาบัตรที่มีรูปถ่ายของเจ้าของบัตรซึ่งออกโดยหน่วยงานราชการหรือสำเนาใบแจ้งยอดบัญชีธนาคารล่าสุดสำหรับบัตรเครดิตหรือบัตรเดบิตที่ใช้สำหรับการซื้อในครั้งนั้น
              ๆ ไป ทั้งนี้ หากท่านไม่ชำระค่าบริการที่มีการเรียกเก็
              เราขอสงวนสิทธิในการยกเลิกการให้บริการแก่ท่าน
            </p>
            <p>
              เราขอสงวนสิทธิในการเปลี่ยนแปลงผลิตภัณฑ์ บริการ
              ราคาผลิตภัณฑ์หรือบริการ และกิจกรรมที่เกี่ยวข้องกับ Consent Wow
              ได้ตลอดเวลา และเราขอสงวนสิทธิในการปฏิเสธคำสั่งซื้อใด ๆ
              ที่ท่านสั่งซื้อกับเรา โดยเราอาจจำกัดคำสั่งซื้อตามดุลยพินิจของเรา
            </p>
            <p>
              ข้อจำกัดเหล่านี้อาจรวมไปถึงคำสั่งซื้อที่ดำเนินการซื้อโดยหรือภายใต้บัญชีลูกค้าเดียวกัน
              บัตรเครดิตเดียวกัน
              และ/หรือคำสั่งซื้อที่ใช้การเรียกชำระค่าธรรมเนียม
              และ/หรือที่อยู่ที่ใช้ในการจัดส่ง
              ในกรณีที่เราทำการเปลี่ยนแปลงหรือยกเลิกคำสั่งซื้อ
              เราจะพยายามแจ้งให้ท่านทราบโดยติดต่อไปทางอีเมลและ/หรือที่อยู่สำหรับการเรียกชำระค่าธรรมเนียม
              หรือหมายเลขโทรศัพท์ที่ท่านได้ให้ไว้ในขณะที่ทำการสั่งซื้อ
            </p>
            <p>
              Consent Wow นำเสนอผลิตภัณฑ์และบริการเพื่อการจำหน่าย
              เมื่อเราได้รับคำสั่งซื้อและการชำระค่าธรรมเนียมของท่านและการชำระค่าธรรมเนียมนั้นได้ผ่านการตรวจสอบการฉ้อโกงเรียบร้อยแล้ว
              เราจะให้สิทธิในการเข้าถึงผลิตภัณฑ์หรือบริการที่ซื้อแก่ท่านโดยเร็วที่สุด
              ผลิตภัณฑ์ที่ไม่เสียค่าใช้จ่ายจะมีการจำกัดระบบการใช้งาน
              และค่าธรรมเนียมทั้งหมดไม่สามารถขอคืนได้
            </p>
          </>
        ),
      },
      {
        title: 'นโยบายการคืนเงิน',
        scrollTo: 'terms-refund-policy',
        content: (
          <p>
            เนื่องจากบริการของเรานำเสนอผลิตภัณฑ์ที่จับต้องไม่ได้และไม่สามารถเพิกถอนหลังจากที่เราได้ให้สิทธิการเข้าถึงแก่ท่านไปแล้ว
            เราจึงขอสงวนสิทธิในการคืนเงินให้กับท่านหลังจากที่ได้ทำการชำระเงินสำหรับผลิตภัณฑ์
            ซึ่งท่านรับทราบก่อนที่จะซื้อผลิตภัณฑ์และบริการใด ๆ บนเว็บไซต์
            Consent Wow แล้ว
            โปรดอ่านรายละเอียดการบริการอย่างละเอียดก่อนตัดสินใจทำการสั่งซื้อบริการ
          </p>
        ),
      },
      {
        title: 'ความถูกต้องและสมบูรณ์ของข้อมูล',
        scrollTo: 'terms-accuracy-of-information',
        content: (
          <p>
            ในบางโอกาส ข้อมูลบนเว็บไซต์ Consent Wow อาจมีข้อผิดพลาด เช่น
            มีการสะกดผิด ความไม่ถูกต้องของข้อมูล
            หรือการละเว้นในบางจุดที่อาจมีความเกี่ยวข้องกับรายการส่งเสริมการขายและข้อเสนอ
            เราขอสงวนสิทธิ์ในการแก้ไขข้อผิดพลาด ความไม่ถูกต้องหรือการละเว้นใด ๆ
            และในการการเปลี่ยนแปลง
            ทำให้ข้อมูลเป็นปัจจุบันหรือยกเลิกคำสั่งซื้อหากข้อมูลใด ๆ บนเว็บไซต์
            Consent Wow
            หรือบริการที่เกี่ยวข้องมีความไม่ถูกต้องเมื่อใดก็ได้โดยไม่จำเป็นต้องแจ้งให้ท่านทราบล่วงหน้า
            (รวมถึงหลังจากที่ท่านส่งคำสั่งซื้อแล้ว)
            เราไม่มีหน้าที่ในการทำให้ข้อมูลเป็นปัจจุบัน แก้ไข
            หรือชี้แจงในข้อมูลบนเว็บไซต์ Consent Wow
            ซึ่งรวมไปถึงแต่ไม่จำกัดไว้เพียง ข้อมูลราคา
            เว้นแต่ว่ากฎหมายได้มีการกำหนดให้ต้องกระทำ
            จะไม่มีการกำหนดวันที่หรือวันที่มีเปลี่ยนแปลงบนเว็บไซต์ Consent Wow
            หรือบริการอื่น ๆ ที่เกี่ยวข้องเมื่อมีการแก้ไขหรือทำให้เป็นปัจจุบัน
          </p>
        ),
      },
      {
        title: 'บริการของบุคคลที่สาม',
        scrollTo: 'terms-third-party-services',
        content: (
          <p>
            หากท่านได้เลือกที่จะเปิดใช้ เข้าถึง หรือใช้บริการของบุคคลที่สาม
            ขอให้ท่านคำนึงเอาไว้ว่าการเข้าใช้หรือใช้งานบริการดังกล่าวได้ถูกกำหนดโดยเงื่อนไขและข้อกำหนดของการให้บริการอื่นนั้นแต่เพียงผู้เดียว
            และทางเราจะไม่ขอรับรอง มีหน้าที่หรือรับผิดชอบ
            และไม่ขอให้คำรับรองสำหรับบริการอื่นดังกล่าว
            ซึ่งรวมไปถึงแต่ไม่จำกัดไว้เพียงเนื้อหาหรือวิธีที่บุคคลเหล่านั้นจัดการกับข้อมูล
            (รวมถึงข้อมูลส่วนบุคคลของท่าน)
            หรือการติดต่อกันระหว่างท่านและผู้ให้บริการอื่นนั้น
            ท่านขอสละสิทธิ์โดยไม่เปลี่ยนแปลงว่าจะไม่เรียกร้องจากบริษัท
            เอ็นเดต้าธอธ จำกัด ในเรื่องที่เกี่ยวข้องกับการบริการอื่นดังกล่าว
            บริษัท เอ็นเดต้าธอธ จำกัด
            จะไม่รับผิดชอบต่อความเสียหายหรือความสูญเสียที่ได้เกิดขึ้นหรือถูกกล่าวหาว่าได้เกิดขึ้นโดยหรือเกี่ยวข้องกับการที่ท่านเลือกใช้
            เข้าถึง หรือใช้บริการอื่นดังกล่าว
            หรือจากการที่ท่านได้ไว้วางใจในการปฏิบัติต่อความเป็นส่วนตัว
            ความปลอดภัยของการประมวลผลข้อมูล หรือนโยบายอื่นใดของบริการดังกล่าว
            ท่านอาจจำเป็นจะต้องสมัครหรือลงชื่อเข้าใช้การบริการอื่นดังกล่าวกับเว็บไซต์อื่นนั้น
            ๆ การที่ท่านได้เลือกที่จะเปิดใช้การบริการอื่นดังกล่าวนั้น
            ท่านได้อนุญาตบริษัท เอ็นเดต้าธอธ
            จำกัดโดยชัดแจ้งในการเปิดเผยข้อมูลของท่านเท่าที่จำเป็นในการช่วยให้ใช้งานหรือเปิดการใช้งานบริการอื่นดังกล่าว
          </p>
        ),
      },
      {
        title: 'การรับประกันระยะเวลาที่ทำงานอย่างมีประสิทธิภาพ',
        scrollTo: 'terms-warranty',
        content: (
          <p>
            เราเสนอบริการที่รับประกันระยะเวลาที่ทำงานอย่างมีประสิทธิภาพที่อยู่ในอัตราร้อยละ
            99 จากระยะเวลาที่ทำงานได้ต่อเดือน
            หากเราไม่รักษาไว้ซึ่งการรับประกันระยะเวลาที่ทำงานอย่างมีประสิทธิภาพในเดือนนั้น
            (ตามที่ได้กำหนดไว้โดยเรา)
            ท่านสามารถติดต่อเราและร้องขอเครดิตคืนจากค่าธรรมเนียมบริการของท่านในเดือนดังกล่าวได้
            เครดิตสามารถใช้เพียงสำหรับการซื้อผลิตภัณฑ์หรือบริการเพิ่มเติมจากเราเพียงเท่านั้นและไม่รวมค่าภาษีที่อาจเกิดขึ้น
            การรับประกันระยะเวลาที่ทำงานอย่างมีประสิทธิภาพจะไม่รวมความขัดข้องของการบริการที่เกิดขึ้นโดย
            (1)
            การดูแลรักษาหรือซ่อมแซมตามช่วงระยะเวลาที่เราอาจดำเนินการเป็นครั้งคราว
            (2) ความขัดข้องที่เกิดขึ้นโดยท่านหรือจากการกระทำของท่าน (3)
            ไฟฟ้าขัดข้องที่ไม่ส่งผลกระทบต่อระบบการทำงานหลักของบริการ (4)
            ได้เกิดขึ้นโดยเหนือการควบคุมของเราหรือมีเหตุผลว่าเราไม่สามารถคาดหมายได้
            (5) ไฟฟ้าขัดข้องที่เกี่ยวข้องกับสภาพแวดล้อมในการเขียนโปรแกรมบางอย่าง
          </p>
        ),
      },
      {
        title: 'การสำรองข้อมูล',
        scrollTo: 'terms-backup',
        content: (
          <p>
            เราทำการสำรองข้อมูลเว็บไซต์ Consent Wow
            และเนื้อหาไว้เป็นประจำและเราจะกระทำอย่างสุดความสามารถเพื่อให้มั่นใจได้ว่าข้อมูลที่ทำการสำรองนั้นมีความครบถ้วนและถูกต้องที่สุด
            เราจะทำการกู้คืนข้อมูลที่สำรองไว้โดยอัตโนมัติเพื่อทำให้ผลกระทบหรือช่วงเวลาที่ไม่สามารถทำงานได้
            (downtime) มีอัตราที่ลดลง
          </p>
        ),
      },
      {
        title: 'เชื่อมต่อไปยังเว็บไซต์อื่น',
        scrollTo: 'terms-links-to-other-websites',
        content: (
          <p>
            แม้ว่าเว็บไซต์ Consent Wow นี้อาจมีการเชื่อมต่อไปยังเว็บไซต์อื่น
            เราไม่ได้อนุมัติโดยเป็นนัยยะ ร่วมกัน สนับสนุน ช่วยเหลือ
            หรือเป็นเครือเดียวกันกับเว็บไซต์อื่นที่ได้มีการเชื่อมต่อไม่ว่าจะทางตรงหรืออ้อม
            เว้นเสียแต่ได้กำหนดไว้เป็นการเฉพาะไว้ในที่นี้
            เราไม่มีหน้าที่ในการตรวจสอบหรือประเมิน
            และเราไม่ขอรับรองในข้อเสนอของธุรกิจหรือบุคคลใด ๆ
            หรือเนื้อหาในเว็บไซต์นั้น เราไม่รับผิดชอบหรือรับผิดใด ๆ ต่อการกระทำ
            ผลิตภัณฑ์ บริการและเนื้อหาของบุคคลอื่น ๆ ดังนั้น
            ท่านควรตรวจสอบการชี้แจงทางกฎหมายและเงื่อนไขในการใช้งานของเว็บไซต์ใด
            ๆ ที่ท่านได้เชื่อมต่อผ่านเว็บไซต์ Consent Wow นี้
            ท่านเป็นผู้รับความเสี่ยงที่อาจเกิดขึ้นทั้งหมดในการเชื่อมต่อไปยังเว็บไซต์อื่น
            ๆ
          </p>
        ),
      },
      {
        title: 'ข้อห้ามในการใช้งาน',
        scrollTo: 'terms-prohibited-uses',
        content: (
          <>
            <p>
              นอกจากข้อตกลงอื่นที่ได้กำหนดไว้ภายใต้ข้อกำหนดและเงื่อนไขฯ
              ห้ามมิให้ท่านใช้งานเว็บไซต์ Consent Wow หรือเนื้อหาในลักษณะดังนี้
            </p>
            <ol>
              <li>
                เพื่อวัตถุประสงค์นอกเหนือจากที่กำหนดไว้ในข้อกำหนดและเงื่อนไขฯ
                ฉบับนี้
              </li>
              <li>เพื่อวัตถุประสงค์ที่มิชอบด้วยกฎหมาย</li>
              <li>
                ชักชวนหรือสนับสนุนผู้อื่นให้ดำเนินการหรือมีส่วนร่วมในการกระทำที่ผิดกฎหมาย
              </li>
              <li>
                ละเมิดกฎระเบียบ ข้อบังคับ
                กฎหมายหรือข้อบัญญัติท้องถิ่นระหว่างประเทศ รัฐบาลกลาง
                จังหวัดหรือรัฐ
              </li>
              <li>
                กระทำการละเมิดสิทธิในทรัพย์สินทางปัญญาใด ๆ
                ของเราหรือสิทธิในทรัพย์สินทางปัญญาของผู้อื่น
              </li>
              <li>
                คุกคาม ล่วงละเมิด ดูหมิ่น ทำร้าย ทำให้เสียชื่อเสียง ใส่ร้าย
                ดูหมิ่น ข่มขู่หรือเลือกปฏิบัติตามเพศ รสนิยมทางเพศ ศาสนา
                ชาติพันธุ์ เชื้อชาติ อายุ ชาติกำเนิดหรือความทุพพลภาพ
              </li>
              <li>นำส่งข้อมูลเท็จหรือบิดเบือนข้อมูล</li>
              <li>
                เพื่ออัปโหลดหรือส่งไวรัสหรือรหัสที่เป็นอันตรายประเภทอื่นที่จะหรืออาจใช้ในลักษณะใด
                ๆ
                ที่จะส่งผลกระทบต่อการทำงานหรือการทำงานของบริการหรือเว็บไซต์ที่เกี่ยวข้อง
                เว็บไซต์อื่น ๆ หรืออินเทอร์เน็ต
              </li>
              <li>เก็บรวบรวมหรือติดตามข้อมูลส่วนบุคคลของผู้อื่น</li>
              <li>
                การส่งข้อความที่ผู้รับไม่ได้ร้องขอ (spam)
                การหลอกลวงโดยใช้อีเมลหรือหน้าเว็บไซต์ปลอม (phish)
                การเปลี่ยนแปลงเส้นทางการเข้าชมเว็บไซต์ไปยังเว็บไซต์ปลอมเพื่อโจรกรรมข้อมูลผู้ใช้
                (pharm) แอบอ้างเป็นผู้มีสิทธิเข้าถึงข้อมูล (pretext)
                การใช้โปรแกรมเก็บรวบรวมข้อมูลบนเว็บไซต์ (spider)
                การเก็บรวบรวมข้อมูลเว็บไซต์ (crawl)
                หรือการดึงข้อมูลจากเว็บไซต์อื่น ๆ เพื่อนำมาใช้งาน (scrape)
              </li>
              <li>เพื่อวัตถุประสงค์ในทางอนาจารหรือผิดศีลธรรม หรือ</li>
              <li>
                เพื่อแทรกแซงหรือหลีกเลี่ยงคุณลักษณะทางด้านความปลอดภัยของบริการหรือเว็บไซต์ที่เกี่ยวข้อง
                เว็บไซต์อื่น ๆ หรืออินเทอร์เน็ต
              </li>
            </ol>
            <p>
              เราขอสงวนสิทธิ์ในการยกเลิกการใช้บริการหรือใช้เว็บไซต์ Consent Wow
              ใด ๆ ของท่านจากการฝ่าฝืนการใช้งานที่ต้องห้าม
            </p>
          </>
        ),
      },
      {
        title: 'สิทธิในทรัพย์สินทางปัญญา',
        scrollTo: 'terms-intellectual-property-rights',
        content: (
          <>
            <p>
              ข้อกำหนดและเงื่อนไขฯ นี้จะไม่เป็นการโอนสิทธิในทรัพย์สินทางปัญญาใด
              ๆ ที่เป็นของ บริษัท เอ็นเดต้าธอธ จำกัด หรือบุคคลที่สามไปให้แก่ท่าน
              โดยสิทธิ กรรมสิทธิ์
              และผลประโยชน์ในทั้งหมดของทรัพย์สินดังกล่าวซึ่งไม่จำกัดไว้เพียงลิขสิทธิ์
              สิทธิบัตร
              สิทธิในความลับทางการค้าและสิทธิในทรัพย์สินทางปัญญาอื่นใดจะยังคงอยู่
              (ในระหว่างคู่สัญญา) กับ บริษัท เอ็นเดต้าธอธ จำกัดแต่เพียงผู้เดียว
              เครื่องหมายทางการค้า เครื่องหมายบริการ กราฟิก
              และโลโก้ทั้งหมดที่ถูกใช้เกี่ยวกับเว็บไซต์ Consent Wow
              และบริการของเรา หรือเว็บไซต์ที่เป็นกิจกรรมเกี่ยวข้องกับ Consent
              Wow
              เป็นเครื่องหมายทางการค้าหรือเครื่องหมายทางการค้าที่ได้จดทะเบียนของ
              บริษัท เอ็นเดต้าธอธ จำกัดหรือผู้อนุญาตให้สิทธิในการใช้แก่บริษัท
              เอ็นเดต้าธอธ จำกัดเครื่องหมายการค้า เครื่องหมายการบริการ กราฟิก
              และโลโก้
              ที่ใช้ร่วมกับเว็บไซต์หรือบริการของเราอาจเป็นเครื่องหมายการค้าของบุคคลที่สามอื่น
              การใช้งานเว็บไซต์ Consent Wow
              และบริการของท่านจะไม่เป็นการให้สิทธิหรืออนุญาตให้ท่านทำซ้ำหรือใช้เครื่องหมายการค้าใดของบริษัท
              เอ็นเดต้าธอธ จำกัด หรือของบุคคลที่สาม
            </p>
          </>
        ),
      },
      {
        title: 'การสงวนสิทธิในการรับประกัน',
        scrollTo: 'terms-disclaimer-of-warranty',
        content: (
          <>
            <p>
              ท่านยอมรับว่าการใช้งานเว็บไซต์ Consent Wow บริการ
              หรือการเข้าร่วมในกิจกรรมที่เกี่ยวข้องกับบริการของ Consent Wow
              ที่ทางเราได้จัดขึ้น
              เป็นการที่ท่านยอมรับความเสี่ยงเองแต่เพียงผู้เดียว
              ท่านยอมรับว่าบริการดังกล่าวจัดเตรียมมีให้ในรูปแบบ
              &quot;ตามที่เป็นอยู่&quot; และ &quot;ตามที่มีอยู่&quot;
              เราขอปฏิเสธการรับประกันใด ๆ โดยชัดแจ้ง ไม่ว่าโดยชัดแจ้งหรือโดยนัย
              ซึ่งรวมถึงแต่ไม่จำกัดเพียง
              การรับประกันโดยนัยเกี่ยวกับความสามารถทางการค้า
              ความเหมาะสมสำหรับวัตถุประสงค์เฉพาะ
              และการไม่เกิดเหตุละเมิดการใช้งาน
              เราไม่รับประกันว่าบริการจะตรงตามความต้องการของท่านหรือบริการจะไม่ขัดข้อง
              ใช้ได้ตลอดเวลา ปลอดภัย หรือปราศจากข้อผิดพลาด และเราไม่รับประกันใด
              ๆ
              เกี่ยวกับผลลัพธ์ที่อาจได้รับจากการใช้บริการและการเข้าร่วมกิจกรรมของท่านหรือความถูกต้องหรือความน่าเชื่อถือของข้อมูลใด
              ๆ
              ที่ได้รับผ่านบริการหรือข้อบกพร่องที่เกิดขึ้นในบริการจะได้รับการแก้ไข
              ท่านเข้าใจและยอมรับว่าเนื้อหาและ / หรือข้อมูลใด ๆ
              ที่ได้ดาวน์โหลดหรือได้รับจากการใช้บริการจะได้กระทำขึ้นและอยู่กับดุลยพินิจและความเสี่ยงของท่านเองและท่านจะต้องรับผิดชอบแต่เพียงผู้เดียวสำหรับความเสียหายที่เกิดขึ้นกับระบบคอมพิวเตอร์ของท่านหรือการสูญเสียข้อมูลอันเป็นผลมาจาก
              ดาวน์โหลดสิ่งนั้นและ / หรือข้อมูลดังกล่าว
              เราไม่รับประกันสินค้าหรือบริการใด ๆ
              ที่ซื้อหรือได้รับผ่านบริการหรือธุรกรรมใด ๆ ที่ทำผ่านบริการ
              คำปรึกษาทางกฎหมายหรือข้อมูลที่กระทำโดยวาจาหรือลายลักษณ์อักษรที่ท่านได้รับจากเราหรือผ่านการบริการของเราจะไม่เป็นการรับรองในสิ่งที่ไม่ได้มีการระบุไว้ภายใต้สัญญานี้
            </p>
            <p>
              ท่านยินยอมและรับทราบว่า บริษัท เอ็นเดต้าธอธ จำกัด
              มิใช่สำนักงานกฎหมาย นักกฎหมาย ทนายความ
              หรือให้บริการคำปรึกษาทางกฎหมาย ดังนั้น
              เราจะไม่รับรองในความถูกต้องทางกฎหมายหรือการบังคับใช้ได้ของเนื้อหา
              คำแนะนำ หรือเอกสารต่าง ๆ
              ที่ท่านจะได้รับจากการบริการสำหรับความต้องการที่เกี่ยวข้องกับข้อกฎหมายของท่าน
            </p>
          </>
        ),
      },
      {
        title: 'ข้อจำกัดความรับผิด',
        scrollTo: 'terms-limitation-of-liability',
        content: (
          <>
            <p>
              ตามขอบเขตสูงสุดของกฎหมายที่บังคับใช้ได้อนุญาต ไม่ว่าในกรณีใดก็ตาม
              บริษัท เอ็นเดต้าธอธ จำกัด บริษัทในเครือ เจ้าหน้าที่ กรรมการ
              พนักงาน ตัวแทน คู่ค้า หรือผู้ได้รับอนุญาตของบริษัท เอ็นเดต้าธอธ
              จำกัดจะไม่รับผิดชอบต่อบุคคลใด ๆ สำหรับเรื่องต่อไปนี้ (ก)
              ความเสียหายทางอ้อม ความเสียหายโดยไม่ตั้งใจ ความเสียหายพิเศษ
              ความเสียหายในเชิงลงโทษ ความเสียหายในการชดใช้
              หรือความเสียหายที่เป็นผลสืบเนื่อง (ซึ่งรวมถึงแต่ไม่จำกัดเพียง
              ความเสียหายจากผลกำไร รายได้ การค้าขาย ค่าความนิยม การใช้เนื้อหา
              ผลกระทบต่อธุรกิจ ธุรกิจหยุดชะงัก
              การสูญเสียเงินเก็บที่คาดการณ์เอาไว้ การสูญเสียโอกาสทางธุรกิจ)
              อย่างไรก็ตาม ความรับผิดชอบที่เกิดขึ้นในทางที่จะเป็นได้
              ซึ่งรวมไปถึงแต่ไม่จำกัดเพียงในทางสัญญา ละเมิด การรับรอง
              การผิดจารีตประเพณี ประมาท หรือการใดที่บริษัท เอ็นเดต้าธอธ
              จำกัดได้รับคำชี้แจงมาแล้วว่าอาจเกิดขึ้นได้หรือคาดหมายได้ว่าความเสียหายดังกล่าวอาจจะเกิดขึ้นก็ตาม
              ตามขอบเขตสูงสุดของกฎหมายที่บังคับใช้ได้อนุญาต
              จำนวนความเสียหายทั้งหมดที่เกี่ยวข้องกับบริการหรือกิจกรรมที่เกี่ยวข้องซึ่งจะต้องรับผิดโดย
              บริษัท เอ็นเดต้าธอธ จำกัดและบริษัทในเครือ เจ้าหน้าที่ กรรมการ
              พนักงาน ตัวแทน คู่ค้า หรือผู้ได้รับอนุญาตของบริษัท เอ็นเดต้าธอธ
              จำกัดจะถูกจำกัดไว้ตามจำนวนจริงที่ท่านได้ชำระให้แก่บริษัท
              เอ็นเดต้าธอธ
              จำกัดข้อจำกัดและการยกเว้นจะไม่มีผลบังคับใช้หากวิธีการเยียวยานี้ไม่สามารถชดเชยความเสียหาย
              ความสูญเสียหรือผิดพลาด ในวัตถุประสงค์หลักได้
            </p>
          </>
        ),
      },
      {
        title: 'การชดใช้ค่าเสียหาย',
        scrollTo: 'terms-indemnification',
        content: (
          <p>
            ท่านตกลงที่จะชดใช้ค่าเสียหายและปกป้อง บริษัท เอ็นเดต้าธอธ จำกัด และ
            บริษัทในเครือ กรรมการ เจ้าหน้าที่ พนักงาน
            และตัวแทนจากหรือต่อความรับผิด ความสูญเสีย ความเสียหายหรือค่าใช้จ่าย
            รวมถึงค่าทนายความที่เหมาะสม ที่เกี่ยวเนื่องหรือเกิดขึ้นจากข้อกล่าวหา
            ข้อเรียกร้อง การกระทำ ข้อพิพาท
            หรือการดำเนินการข้อพิพาทหรือข้อเรียกร้องใด ๆ
            ของบุคคลที่สามอันเป็นผลมาจากหรือเกี่ยวกับเนื้อหาของท่าน
            การใช้งานเว็บไซต์ Consent Wow หรือบริการโดยท่าน
            การเข้าร่วมกิจกรรมที่จัดขึ้นโดยเรา หรือการกระทำอันมิชอบโดยเจตนาใด ๆ
            ของท่าน
          </p>
        ),
      },
      {
        title: 'การแยกข้อสัญญาส่วนที่เป็นโมฆะออกจากส่วนที่ไม่เป็นโมฆะ',
        scrollTo: 'terms-severability',
        content: (
          <p>
            สิทธิและข้อจำกัดทั้งหมดที่มีอยู่ในข้อกำหนดและเงื่อนไขฯ
            ฉบับนี้อาจถูกใช้
            จะมีผลบังคับใช้และมีผลผูกพันเฉพาะในขอบเขตที่ข้อจำกัดนั้นไม่ฝ่าฝืนกฎหมายที่เกี่ยวข้องใด
            ๆ
            และมีเจตนาที่จำกัดอยู่ในขอบเขตที่จำเป็นเพื่อที่จะไม่ทำให้ข้อกำหนดและเงื่อนไขฯ
            ฉบับนี้ผิดกฎหมาย ไม่เป็นผล หรือไม่สามารถบังคับใช้ได้
            หากข้อกำหนดหรือส่วนใดส่วนหนึ่งของข้อกำหนดใด ๆ
            ของข้อกำหนดและเงื่อนไขฯ ฉบับนี้ผิดกฎหมาย ไม่เป็นผล
            หรือไม่สามารถบังคับใช้ได้โดยศาลที่มีอำนาจ
            คู่สัญญาตกลงว่าบทบัญญัติหรือส่วนที่เหลืออยู่จะยังเป็นข้อตกลงที่ยังคงมีผลบังคับใช้ได้ต่อไป
          </p>
        ),
      },
      {
        title: 'เนื้อหาและการโพสต์',
        scrollTo: 'terms-copyright',
        content: (
          <>
            <p>
              ท่านไม่สามารถแก้ไข พิมพ์ หรือทำสำเนาในส่วนใดของเว็บไซต์ Consent
              Wow การนำบางส่วนของเว็บไซต์ Consent Wow ไปรวมเข้ากับงานอื่น
              ไม่ว่าจะเป็นในรูปแบบสื่อพิมพ์หรืออิเล็กทรอนิกส์หรือรูปแบบอื่นใดก็ตาม
              หรือนำบางส่วนของเว็บไซต์ Consent Wow
              ไปรวมไว้ในเว็บไซต์อื่นในรูปแบบการฝังไว้ในเว็บไซต์ (embedding)
              แบ่งไว้เป็นส่วนในหน้าเว็บไซต์ (framing)
              หรือวิธีการอื่นใดโดยไม่ได้รับอนุญาตที่ชัดแจ้งจากเรา
              จะถือเป็นสิ่งต้องห้ามในการกระทำ
            </p>
            <p>
              ท่านจะต้องไม่ทำการอัปโหลดเนื้อหาที่เป็นการหมิ่นประมาท ฉ้อฉล อนาจาร
              หมิ่นประมาท คุกคาม ล่วงล้ำในสิทธิความเป็นส่วนตัวของผู้อื่น
              หรือทางอื่นใดที่ไม่ชอบด้วยกฎหมาย
              ท่านจะต้องไม่ทำการละเมิดในทรัพย์สินทางปัญญาของบุคคลหรือบริษัทอื่น
              ท่านจะต้องไม่ทำการอัปโหลดไวรัสคอมพิวเตอร์หรือโค้ดอื่นใดที่จัดทำขึ้นเพื่อทำให้เกิดความขัดข้อง
              เสียหาย
              หรือจำกัดระบบการทำงานของซอฟต์แวร์หรือฮาร์ดแวร์ของคอมพิวเตอร์
              ในการนำส่งหรืออัปโหลดไฟล์บนเว็บไซต์ Consent Wow
              ถือว่าท่านได้ยินยอมให้เราในการนำออกซึ่งไฟล์ใด ๆ ในเวลาใด ๆ ก็ได้
            </p>
          </>
        ),
      },
      {
        title: 'การระงับข้อพิพาท',
        scrollTo: 'terms-dispute-resolution',
        content: (
          <p>
            การเริ่มทำ ตีความ
            และการปฏิบัติภายใต้สัญญาฉบับนี้และข้อพิพาทที่ได้เกิดขึ้นจากข้อกำหนดและเงื่อนไขฯ
            ฉบับนี้จะต้องตกอยู่ภายใต้วิธีการพิจารณากฎหมายแห่งราชอาณาจักรแห่งไทยโดยไม่ต้องคำนึงถึงความขัดแย้งทางกฎหมายและกฎหมายแห่งราชอาณาจักรไทยตามที่สามารถกระทำได้
            เขตอำนาจศาลและสถานที่เดียวสำหรับการดำเนินการทางกฎหมายที่เกี่ยวข้องกับประเด็นข้อพิพาทในเรื่องของข้อกำหนดและเงื่อนไขฯ
            ฉบับนี้ให้อยู่ในเขตอำนาจศาลแห่งราชอาณาจักรแห่งประเทศไทยและท่านจะนำข้อพิพาทเข้าสู่เขตอำนาจศาลดังกล่าว
          </p>
        ),
      },
      {
        title: 'การโอนสิทธิ',
        scrollTo: 'terms-transfer-of-rights',
        content: (
          <p>
            ท่านจะต้องไม่ทำการโอน ขายต่อ อนุญาตช่วง
            หรือทำการโอนย้ายหรือมอบหมายในสิทธิหรือหน้าที่ใด ๆ
            ของท่านที่ได้กำหนดไว้ไม่ว่าจะทั้งหมดหรือบางส่วนโดยไม่ได้รับความยินยอมจากพวกเรา
            โดยที่ความยินยอมของพวกเรานั้นจะขึ้นอยู่กับดุลพินิจของเราแต่เพียงผู้เดียวโดยและไม่มีเงื่อนไขอื่นใด
            การโอนสิทธิหรือโอนย้ายใด ๆ ดังกล่าวจะต้องเป็นโมฆะและไม่มีผล ทั้งนี้
            เรามีอิสระที่จะโอนสิทธิ์หรือภาระผูกพันใด ๆ
            ไม่ว่าทั้งหมดหรือบางส่วนให้กับบุคคลที่สามซึ่งเป็นส่วนหนึ่งของการขายทรัพย์สินหรือหุ้นทั้งหมดหรือในส่วนสำคัญทั้งหมดหรือเป็นส่วนหนึ่งของการควบรวมกิจการ
          </p>
        ),
      },
      {
        title: 'การเปลี่ยนแปลงและการแก้ไข',
        scrollTo: 'terms-changes-amendments',
        content: (
          <p>
            เราขอสงวนสิทธิในการแก้ไขข้อกำหนดและเงื่อนไขฯ
            ฉบับนี้หรือนโยบายที่เกี่ยวข้องกับเว็บไซต์ Consent Wow
            หรือบริการในเวลาใดก็ได้
            โดยจะมีผลทันทีเมื่อได้ทำการเผยแพร่ข้อกำหนดและเงื่อนไขฯ
            ฉบับล่าสุดลงบนเว็บไซต์ Consent Wow
            โดยเราจะทำการระบุวันที่มีการแก้ไขลงไว้ข้างใต้ของข้อกำหนดและเงื่อนไขฯ
            การเข้าใช้งานเว็บไซต์ Consent Wow
            หลังจากที่มีการแก้ไขดังกล่าวจะถือเป็นการที่ท่านได้ยินยอมในการแก้ไขนั้น
            ๆ
          </p>
        ),
      },
      {
        title: 'การยอมรับในข้อตกลง',
        scrollTo: 'terms-acceptance-of-these-terms',
        content: (
          <p>
            ท่านยอมรับและรับทราบว่าท่านได้อ่านข้อกำหนดและเงื่อนไขฯ
            ฉบับนี้และยินยอมในข้อตกลงและเงื่อนไขทั้งหมดดังกล่าว
            ในการใช้งานเว็บไซต์ Consent Wow
            หรือบริการย่อมถือว่าท่านได้ยินยอมที่จะผูกพันกับข้อกำหนดและเงื่อนไขฯ
            ฉบับนี้ หากท่านไม่ยินยอมในข้อตกลงของข้อกำหนดและเงื่อนไขฯ ฉบับนี้
            ท่านจะไม่มีสิทธิในการใช้งานหรือเข้าถึงเว็บไซต์ Consent Wow
            หรือบริการดังกล่าว
          </p>
        ),
      },
      {
        title: 'รายละเอียดการติดต่อ',
        scrollTo: 'terms-contacting-us',
        content: ContactingUs,
      },
    ],
  },
  privacy: {
    title: 'นโยบายความเป็นส่วนตัว',
    linkTo: '/privacy-policy',
    subMenus: [
      {
        title: 'ข้อมูลที่ทางเราเก็บรวบรวมโดยอัตโนมัติ',
        scrollTo: 'privacy-automated-collection-of-information',
        content: (
          <>
            <p>
              เมื่อท่านเยี่ยมชมเว็บไซต์ Consent Wow
              เซิร์ฟเวอร์ของเราจะบันทึกข้อมูลที่เบราว์เซอร์ของท่านส่งโดยอัตโนมัติ
              ข้อมูลเหล่านั้นอาจได้แก่ IP Address ของอุปกรณ์ท่าน
              ชนิดและเวอร์ชั่นของเบราว์เซอร์ ชนิดและเวอร์ชั่นของระบบปฏิบัติการ
              ภาษาที่ท่านเลือกใช้หรือหน้าเว็บไซต์ที่ท่านได้เยี่ยมชมก่อนเข้าสู่เว็บไซต์
              Consent Wow หน้าของเว็บไซต์ Consent Wow ที่ท่านได้เยี่ยมชม
              ระยะเวลาที่เยี่ยมชมเว็บไซต์เหล่านั้น ข้อมูลที่ท่านค้นหาบนเว็บไซต์
              Consent Wow วันและเวลาที่เข้าชม และสถิติอื่น ๆ
            </p>
            <p>
              ข้อมูลที่ถูกรวบรวมโดยอัตโนมัติจะใช้เพื่อระบุการละเมิดที่อาจเกิดขึ้นและสร้างข้อมูลทางสถิติเกี่ยวกับการใช้งานเว็บไซต์
              Consent Wow
              โดยข้อมูลทางสถิตินี้จะไม่ถูกรวบรวมในลักษณะที่ทำให้ระบุผู้ใช้รายใดรายหนึ่งของระบบได้
            </p>
          </>
        ),
      },
      {
        title: 'การเก็บรวบรวมข้อมูลส่วนบุคคล',
        scrollTo: 'privacy-automatically-collection-of-information',
        content: (
          <>
            <p>
              เมื่อท่านเยี่ยมชมเว็บไซต์ Consent Wow
              เซิร์ฟเวอร์ของเราจะบันทึกข้อมูลที่เบราว์เซอร์ของท่านส่งโดยอัตโนมัติ
              ข้อมูลเหล่านั้นอาจได้แก่ IP Address ของอุปกรณ์ท่าน
              ชนิดและเวอร์ชั่นของเบราว์เซอร์ ชนิดและเวอร์ชั่นของระบบปฏิบัติการ
              ภาษาที่ท่านเลือกใช้หรือหน้าเว็บไซต์ที่ท่านได้เยี่ยมชมก่อนเข้าสู่เว็บไซต์
              Consent Wow หน้าของเว็บไซต์ Consent Wow ที่ท่านได้เยี่ยมชม
              ระยะเวลาที่เยี่ยมชมเว็บไซต์เหล่านั้น ข้อมูลที่ท่านค้นหาบนเว็บไซต์
              Consent Wow วันและเวลาที่เข้าชม และสถิติอื่น ๆ
            </p>
            <p>
              ข้อมูลที่ถูกรวบรวมโดยอัตโนมัติจะใช้เพื่อระบุการละเมิดที่อาจเกิดขึ้นและสร้างข้อมูลทางสถิติเกี่ยวกับการใช้งานเว็บไซต์
              Consent Wow
              โดยข้อมูลทางสถิตินี้จะไม่ถูกรวบรวมในลักษณะที่ทำให้ระบุผู้ใช้รายใดรายหนึ่งของระบบได้
            </p>
          </>
        ),
      },
      {
        title: 'ประเภทข้อมูลส่วนบุคคลที่เก็บรวบรวม',
        scrollTo: 'privacy-collection-of-personal-information',
        content: (
          <>
            <p>
              ท่านสามารถเยี่ยมชมเว็บไซต์ Consent Wow
              โดยไม่ต้องบอกเราว่าท่านคือใครหรือเปิดเผยข้อมูลใด ๆ
              ที่ทำให้บุคคลอื่นสามารถระบุตัวตนของท่านได้อย่างเฉพาะเจาะจง
              อย่างไรก็ตาม ท่านจะถูกสอบถามให้บอกกล่าวข้อมูลส่วนบุคคลบางอย่าง
              (เช่น ชื่อและอีเมลของท่าน)
              หากท่านมีความประสงค์ที่จะใช้ระบบการทำงานบางตัวของเว็บไซต์ Consent
              Wow เราจะได้รับและจัดเก็บข้อมูลใด ๆ
              ที่ท่านได้ให้เราไว้โดยที่ท่านรับรู้เมื่อท่านได้ทำการสร้างบัญชีผู้ใช้
              ประกาศเนื้อหา ทำการสั่งซื้อ หรือกรอกแบบฟอร์มบนเว็บไซต์ Consent Wow
              เมื่อมีความจำเป็น โดยข้อมูลเหล่านั้นอาจมีดังนี้
            </p>
            <ul>
              <li>
                ข้อมูลส่วนบุคคล เช่น ชื่อ นามสกุล อายุ วันเดือนปีเกิด
                เลขประจำตัวประชาชน/หนังสือเดินทาง
              </li>
              <li>ข้อมูลการติดต่อ เช่น อีเมล ที่อยู่ หมายเลขโทรศัพท์</li>
              <li>
                ข้อมูลบัญชี เช่น ชื่อผู้ใช้งาน รหัสผู้ใช้งานที่เป็นเอกลักษณ์
                รหัสผ่าน
              </li>
              <li>
                หลักฐานการแสดงตัวตน เช่น สำเนาบัตรประจำตัวประชาชน
                สำเนาหนังสือเดินทาง
              </li>
              <li>
                ข้อมูลการทำธุรกรรมและการเงิน เช่น รายละเอียดบัตรเครดิต
                บัญชีธนาคาร ประวัติการสั่งซื้อ
              </li>
              <li>
                ข้อมูลอื่น ๆ ที่ท่านยินยอมนำส่งให้แก่เรา เช่น บทความ รูปภาพ
                ภาพเคลื่อนไหว ข้อเสนอแนะ
                และข้อมูลอื่นใดที่ถือว่าเป็นข้อมูลส่วนบุคคลตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล
                เป็นต้น
              </li>
            </ul>
            <p>
              ท่านสามารถเลือกที่จะไม่ให้ข้อมูลส่วนบุคคลของท่านแก่เราได้
              แต่ท่านอาจจะไม่ได้รับความสะดวกในการใช้งานระบบการทำงานบางส่วนของเว็บไซต์
              Consent Wow และบริการ
              ผู้ใช้ที่ยังไม่แน่ใจว่าข้อมูลส่วนบุคคลใดที่มีความจำเป็นสามารถติดต่อเพื่อสอบถามเราได้
            </p>
          </>
        ),
      },
      {
        title: 'การจัดการข้อมูลส่วนบุคคล',
        scrollTo: 'privacy-information-management',
        content: (
          <p>
            ท่านสามารถทำการลบข้อมูลส่วนบุคคลที่เราได้เก็บเกี่ยวกับตัวท่านได้
            ข้อมูลส่วนบุคคลที่ท่านสามารถทำการลบได้จะมีการเปลี่ยนแปลงไปตามการเปลี่ยนแปลงของเว็บไซต์
            Consent Wow หรือการบริการ อย่างไรก็ตาม
            เมื่อท่านได้ลบข้อมูลส่วนบุคคลของท่านแล้ว
            เราอาจเก็บรักษาไว้ซึ่งสำเนาของข้อมูลส่วนบุคคลที่ไม่มีการแก้ไขไว้ในบันทึกของเราไว้เป็นระยะเวลาที่จำเป็นสำหรับการปฏิบัติหน้าที่ของเราต่อพันธมิตรหรือหุ้นส่วนของเรา
            และวัตถุประสงค์ที่ได้ระบุไว้ด้านล่างนี้
            หากท่านมีความประสงค์ที่จะลบข้อมูลส่วนบุคคลของท่านหรือลบบัญชีการใช้งานของท่านเป็นการถาวร
            ท่านสามารถทำได้โดยเข้าหน้าการตั้งค่าในบัญชีการใช้งานของท่านบนเว็บไซต์
            Consent Wow หรือทำการติดต่อเราตามความสะดวก
          </p>
        ),
      },
      {
        title: 'การจัดเก็บข้อมูลส่วนบุคคล',
        scrollTo: 'privacy-information-storage',
        content: (
          <>
            <p>
              เราจะเก็บรักษาข้อมูลส่วนบุคคลของท่านไว้ตามระยะเวลาที่จำเป็นสำหรับการปฏิบัติตามหน้าที่ตามกฎหมายของเราเพื่อการยุติข้อพิพาท
              และเพื่อการบังคับใช้สัญญาและข้อกำหนดและเงื่อนไขของเรา
              เว้นเสียแต่มีความจำเป็นที่จะต้องเก็บต่อไปหรือตามที่กฎหมายกำหนด
              เราอาจใช้ข้อมูลที่รวมขึ้นที่ได้มาจากการรวบรวมข้อมูลส่วนบุคคลของท่านที่ได้ทำให้เป็นปัจจุบันหรือลบทิ้งไปแต่เราจะไม่นำมาใช้ในทางที่สามารถระบุตัวตนของท่านได้
              เมื่อครบกำหนดระยะเวลาการจัดเก็บ ข้อมูลส่วนบุคคลจะถูกลบทิ้ง ดังนั้น
              สิทธิขอเข้าถึง สิทธิขอให้ลบ สิทธิขอให้แก้ไข สิทธิขอถ่ายโอนข้อมูล
              จะไม่สามารถบังคับใช้ได้เมื่อครบกำหนดระยะเวลาการจัดเก็บ
            </p>
            <p>
              ข้อมูลส่วนบุคคลของท่านจะถูกส่งไปนอกราชอาณาจักรไทยเนื่องจากระบบโครงสร้างพื้นฐานของเราอยู่ที่ประเทศสิงคโปร์
            </p>
          </>
        ),
      },
      {
        title: 'การใช้และประมวลผลข้อมูลส่วนบุคคลที่เก็บรวบรวม',
        scrollTo: 'privacy-use-and-processing-of-collected-information',
        content: (
          <>
            <p>
              เพื่อทำให้เว็บไซต์ Consent Wow
              และบริการสามารถให้ท่านใช้งานได้หรือเพื่อปฏิบัติตามหน้าที่ตามกฎหมาย
              เราจึงมีความจำเป็นจะต้องเก็บรวบรวมข้อมูลส่วนบุคคลของท่านบางส่วน
              หากท่านไม่อนุญาตให้เราเก็บรวบรวมข้อมูลตามที่เราร้องขอ
              เราอาจจะไม่สามารถจัดเตรียมผลิตภัณฑ์หรือบริการที่ท่านร้องขอได้
              ข้อมูลบางส่วนที่เราได้เก็บรวบรวมนั้นได้มาจากท่านโดยตรงผ่านเว็บไซต์
              Consent Wow อย่างไรก็ตาม
              เราอาจมีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่านจากแหล่งข้อมูลอื่นที่มีอยู่
              รวมถึงแต่ไม่จำกัดเพียง สื่อสังคมออนไลน์ อีเมล
              ข้อมูลส่วนบุคคลที่เราได้เก็บรวบรวมจากท่านอาจนำมาใช้สำหรับวัตถุประสงค์ดังต่อไปนี้
            </p>
            <ol>
              <li>เพื่อสร้างและจัดการบัญชีผู้ใช้งาน</li>
              <li>เพื่อทำการและจัดการคำสั่งซื้อ</li>
              <li>เพื่อจัดส่งผลิตภัณฑ์หรือบริการ</li>
              <li>เพื่อปรับปรุงผลิตภัณฑ์หรือบริการให้ดียิ่งขึ้น</li>
              <li>เพื่อส่งข้อมูลการดูแลจัดการ</li>
              <li>
                เพื่อส่งข้อมูลการสื่อสารทางการตลาดหรือรายการส่งเสริมการขาย
              </li>
              <li>เพื่อตอบสนองต่อข้อสงสัยและนำเสนอการช่วยเหลือ</li>
              <li>เพื่อร้องขอข้อเสนอแนะ</li>
              <li>เพื่อปรับปรุงประสบการณ์การใช้งานของผู้ใช้ให้ดียิ่งขึ้น</li>
              <li>
                เพื่อโพสต์หรือประชาสัมพันธ์ความพึงพอใจของท่านที่มีเกี่ยวกับผลิตภัณฑ์และบริการของเรา
              </li>
              <li>เพื่อบังคับใช้ข้อตกลงและเงื่อนไขและนโยบายต่าง ๆ</li>
              <li>เพื่อปกป้องจากผู้ใช้ที่ไม่ชอบและอันตราย</li>
              <li>
                เพื่อตอบสนองต่อข้อเรียกร้องทางกฎหมายและหลีกเลี่ยงความเสียหาย
              </li>
              <li> เพื่อดำเนินการและจัดการเว็บไซต์ Consent Wow และบริการ</li>
              <li>
                เพื่อมีส่วนร่วมในกิจกรรมอื่นใดที่เกี่ยวข้องกับเว็บไซต์และบริการของ
                Consent Wow
              </li>
            </ol>
            <p>
              การประมวลผลข้อมูลส่วนบุคคลของท่านขึ้นอยู่กับวิธีการที่ใช้เว็บไซต์
              Consent Wow สถานที่ที่ท่านอยู่ และหากหนึ่งในการกระทำดังต่อไปนี้
              (1)
              ท่านได้ให้ความยินยอมสำหรับหนึ่งหรือมากกว่าหนึ่งวัตถุประสงค์ที่เจาะจง
              อย่างไรก็ตาม
              การกระทำนี้จะไม่บังคับใช้หากข้อมูลส่วนบุคคลนั้นตกอยู่ภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคลแห่งประเทศไทย
              (PDPA) (2) ข้อมูลนั้นจำเป็นเพื่อการปฏิบัติตามสัญญาระหว่างท่าน
              และ/หรือเพื่อการปฏิบัติก่อนการเข้าทำสัญญา (3)
              การประมวลผลข้อมูลนั้นมีความจำเป็นเพื่อการปฏิบัติตามกฎหมายที่ท่านอยู่ภายใต้
              (4)
              การประมวลผลข้อมูลนั้นเกี่ยวข้องกับการดำเนินภารกิจเพื่อประโยชน์สาธารณะของเรา
              หรือปฏิบัติหน้าที่ในการใช้อำนาจรัฐที่ได้มอบให้แก่เรา (5)
              การประมวลผลข้อมูลนั้นเป็นการจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมายของเรา
              หรือของบุคคลหรือนิติบุคคลอื่น
            </p>
            <p>
              โปรดทราบว่าภายใต้บางสถานการณ์
              เราอาจได้รับอนุญาตให้ประมวลผลข้อมูลส่วนบุคคลของท่านไปจนกว่าท่านจะทำการคัดค้านการประมวลผลข้อมูลนั้น
              (แจ้งยกเลิก (opt-out)) โดยไม่ต้องอ้างอิงความยินยอมหรือฐานกฎหมายใด
              ๆ ที่ระบุไว้ ในกรณีใดก็ตาม
              เรายินดีที่จะชี้แจงฐานกฎหมายที่เราใช้ในการประมวลผลข้อมูลอย่างเจาะจง
              และในทางเจาะจงว่าการประมวลผลข้อมูลส่วนบุคคลนั้นเป็นไปตามข้อบังคับทางกฎหมายหรือตามหน้าที่ของสัญญา
              หรือมีความจำเป็นสำหรับการเข้าทำสัญญา
            </p>
            <p>
              เราไม่เคยทำการขายข้อมูลของท่านให้แก่บุคคลอื่น
              เราได้ใช้บริการของผู้ประมวลข้อมูลภายนอกดังนี้
            </p>
            <ol>
              <li>
                Amazon Web Services (โครงสร้างพื้นฐานและบริการ/อีเมล
                เว็บโฮสติ้ง) [ประเทศสิงคโปร์]
              </li>
              <li>Slack [ประเทศสหรัฐอเมริกา]</li>
              <li>Crisp [ประเทศสหรัฐอเมริกา]</li>
              <li>Howuku [ประเทศสหรัฐอเมริกา]</li>
              <li>Pipedrive [ประเทศสหรัฐอเมริกา]</li>
              <li>
                Google Workspace [ประเทศสหรัฐอเมริกา/ประเทศสิงคโปร์/ทั่วโลก]
              </li>
              <li>
                Google Analytics [ประเทศสหรัฐอเมริกา/ประเทศสิงคโปร์/ทั่วโลก]
              </li>
              <li>Stripe [ประเทศสหรัฐอเมริกา/ประเทศญี่ปุ่น]</li>
              <li>Facebook Pixel [ประเทศสหรัฐอเมริกา]</li>
              <li>SurveySensum [ประเทศสหรัฐอเมริกา]</li>
              <li>ConvertBox [ประเทศสหรัฐอเมริกา]</li>
              <li>PDPA Form [ประเทศสิงคโปร์/ประเทศไทย]</li>
            </ol>
          </>
        ),
      },
      {
        title: 'การส่งหรือโอนข้อมูลส่วนบุคคลไปต่างประเทศและการจัดเก็บ',
        scrollTo: 'information-transfer-abroad',
        content: (
          <>
            <p>
              เราอาจเปิดเผยหรือโอนข้อมูลส่วนบุคคลของคุณไปยังบุคคล องค์กร
              หรือบนระบบคลาวด์ของ Amazon Web Services (AWS) ณ ประเทศสิงคโปร์
              ทั้งนี้ เราจะดำเนินการตามมาตรการต่าง ๆ
              เพื่อให้มั่นใจว่าการโอนข้อมูลส่วนบุคคลของคุณไปยังประเทศปลายทางนั้นมีมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลอย่างเพียงพอ
              หรือกรณีอื่น ๆ ตามที่กฎหมายกำหนด เว้นแต่
            </p>

            <ol>
              <li>เป็นการปฏิบัติตามกฎหมาย</li>
              <li>
                ได้รับความยินยอมจากคุณหลังจากได้ทำการแจ้งให้คุณทราบถึงมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลที่ไม่เพียงพอของประเทศปลายทาง
              </li>
              <li>
                เป็นการปฏิบัติตามสัญญาที่คุณทำไว้กับเรา
                หรือตามคำขอของคุณก่อนการเข้าทำสัญญา
              </li>
              <li>
                เป็นการปฏิบัติตามสัญญาระหว่างเรากับบุคคล/นิติบุคคลอื่นเพื่อประโยชน์ของคุณ
              </li>
              <li>
                ป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย
                หรือสุขภาพของคุณหรือของบุคคลอื่น
                เมื่อคุณไม่สามารถให้ความยินยอมในขณะนั้นได้
              </li>
            </ol>
          </>
        ),
      },
      {
        title: 'สิทธิของผู้ใช้',
        scrollTo: 'privacy-user-right',
        content: (
          <p>
            ท่านสามารถใช้สิทธิบางประการที่ท่านมีเกี่ยวกับข้อมูลของท่านที่ได้มีการประมวลผลโดยเรา
            โดยเฉพาะอย่างยิ่ง ท่านมีสิทธิดังต่อไปนี้ (1)
            ท่านมีสิทธิในการเพิกถอนความยินยอมที่ท่านให้ไว้ก่อนหน้าในการประมวลผลข้อมูลของท่าน
            อย่างไรก็ตาม
            การเพิกถอนความยินยอมดังกล่าวย่อมไม่ส่งผลกระทบต่อการเก็บรวบรวม ใช้
            หรือเปิดเผยข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมไว้ก่อนหน้าโดยชอบด้วยกฎหมาย(2)
            ท่านมีสิทธิขอคัดค้านการเก็บรวบรวม ใช้
            หรือเปิดเผยข้อมูลส่วนบุคคลของท่านในเวลาใดก็ได้
            เว้นแต่ว่าการเก็บรวบรวม ใช้
            หรือเปิดเผยข้อมูลส่วนบุคคลของท่านนั้นถูกทำขึ้นเพื่อการดำเนินงานที่จำเป็นภายใต้ประโยชน์โดยชอบด้วยกฎหมายของเราหรือของบุคคลหรือนิติบุคคลอื่น
            หรือเพื่อการดำเนินการตามภารกิจเพื่อสาธารณประโยชน์ และการเก็บรวบรวม
            ใช้
            หรือเปิดเผยข้อมูลส่วนบุคคลนั้นไม่เกินขอบเขตที่ท่านสามารถคาดหมายได้อย่างสมเหตุสมผล
            (3) ท่านมีสิทธิในการรับทราบข้อมูลของท่านที่ได้มีการประมวลผลโดยเรา
            ได้รับมาจากการเปิดเผยที่เกี่ยวกับการประมวลผลข้อมูลและขอให้เราทำสำเนาดังกล่าวให้แก่ท่าน
            (4) ท่านมีสิทธิยืนยันความถูกต้องในข้อมูลของท่านและร้องขอให้เรา
            แก้ไขข้อมูลส่วนบุคคลของท่านเพื่อให้ข้อมูลส่วนบุคคลดังกล่าวถูกต้องและเป็นปัจจุบัน
            (5) ท่านมีสิทธิในการระงับการประมวลผลข้อมูลของท่าน ในกรณีดังกล่าว
            เราจะไม่ประมวลผลข้อมูลของท่านนอกเหนือจากการจัดเก็บข้อมูลเพียงเท่านั้น
            (6)
            ท่านมีสิทธิในบางกรณีในการขอให้เราลบข้อมูลส่วนบุคคลของท่านออกจากการจัดเก็บของเรา
            (7)
            ท่านมีสิทธิขอรับข้อมูลส่วนบุคคลของท่านในรูปแบบที่สามารถอ่านหรือใช้งานได้ด้วยเครื่องมือหรืออุปกรณ์ที่ทำงานได้
            และ (หากสามารถทำได้)
            ให้เราส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่นเมื่อสามารถทำได้ด้วยวิธีการดังกล่าว
            สิทธิในข้อนี้จะสามารถทำได้หากข้อมูลของท่านได้ถูกประมวลผลในรูปแบบอัตโนมัติและได้ประมวลผลตามฐานความยินยอม
            ฐานสัญญาที่ท่านเป็นคู่สัญญาหรือก่อนการเข้าทำสัญญา และ (8)
            ท่านมีสิทธิร้องเรียนต่อผู้มีอำนาจตามกฎหมายที่เกี่ยวข้อง
            หากท่านเชื่อว่าการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน
            เป็นการกระทำในลักษณะที่ฝ่าฝืนหรือไม่ปฏิบัติตามกฎหมายที่เกี่ยวข้อง
          </p>
        ),
      },
      {
        title: 'วิธีการใช้สิทธิ',
        scrollTo: 'privacy-right-usage',
        content: (
          <>
            <p>
              การร้องขอใช้สิทธิใด ๆ
              ก็ตามของผู้ใช้สามารถทำได้โดยร้องขอไปยังเราผ่านช่องทางการติดต่อที่เราจัดเตรียมไว้ให้ภายใต้เอกสารฉบับนี้
              การร้องขอใช้สิทธินี้สามารถใช้ได้โดยไม่เสียค่าใช้จ่ายและจะดำเนินการให้โดยเร็วที่สุดโดยเรา
            </p>
            <p>
              แบบฟอร์มออนไลน์สามารถทำการกรอกได้ที่ <a>[--]</a>{' '}
              (โปรดระบุว่าเป็นการร้องขอ Consent Wow)
            </p>
          </>
        ),
      },
      {
        title: 'การเรียกชำระเงินและการชำระเงิน',
        scrollTo: 'privacy-billing-and-payments',
        content: (
          <p>
            เรามีการใช้ผู้ประมวลผลในการชำระเงินที่เป็นบุคคลที่สามเพื่อช่วยเราในการประมวลผลข้อมูลการชำระเงินของท่านให้ปลอดภัย
            การใช้ข้อมูลส่วนบุคคลของท่านโดยผู้ประมวลผลบุคคลที่สามดังกล่าวอยู่จะตกอยู่ภายใต้นโยบายความเป็นส่วนตัวที่เกี่ยวข้องของบุคคลนั้น
            ซึ่งอาจมีหรือไม่มีการคุ้มครองความเป็นส่วนตัวที่มีการป้องกันตามนโยบายนี้
            เราจึงขอแนะนำให้ท่านตรวจสอบนโยบายความเป็นส่วนตัวที่เกี่ยวข้องของบุคคลนั้น
          </p>
        ),
      },
      {
        title: 'ผู้ให้บริการในผลิตภัณฑ์และบริการ',
        scrollTo: 'privacy-service-provider',
        content: (
          <p>
            เราอาจมีการเข้าทำสัญญาร่วมกับบริษัทอื่นเพื่อจัดเตรียมผลิตภัณฑ์หรือบริการบางอย่าง
            ผู้ให้บริการเหล่านี้จะไม่ได้รับอนุญาตให้ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของท่านนอกเหนือจากความจำเป็นในการให้บริการในนามของเราหรือเพื่อปฏิบัติตามข้อกฎหมายที่กำหนด
            เราจะทำการแบ่งปันข้อมูลให้แก่ผู้ให้บริการที่มีนโยบายความเป็นส่วนตัวคล้ายกับเราหรือผู้ให้บริการที่ยินยอมที่จะผูกพันต่อนโยบายของเราที่เกี่ยวข้องกับข้อมูลส่วนบุคคล
            ผู้ให้บริการของเราจะได้รับข้อมูลส่วนบุคคลที่พวกเขาต้องการเพื่อปฏิบัติตามการทำงานที่กำหนดไว้
            และเราจะไม่อนุญาตให้พวกผู้ให้บริการนั้นใช้หรือเปิดเผยข้อมูลส่วนบุคคลเพื่อการตลาดของพวกเขาเองหรือเพื่อวัตถุประสงค์อื่น
            ๆ
          </p>
        ),
      },
      {
        title: 'ความเป็นส่วนตัวของผู้เยาว์',
        scrollTo: 'privacy-minor',
        content: (
          <>
            <p>
              เราจะไม่ทำการเก็บรวบรวมข้อมูลจากผู้เยาว์ที่มีอายุต่ำกว่า 20 ปี
              หากท่านมีอายุที่ต่ำกว่า 20 ปี
              โปรดอย่าทำการนำส่งข้อมูลส่วนบุคคลของท่านผ่านเว็บไซต์ Consent Wow
              หรือบริการ
              เราขอแนะนำให้ผู้ปกครองและผู้มีอำนาจจัดการแทนโดยชอบด้วยกฎหมายทำการสังเกตการณ์การใช้งานอินเทอร์เน็ตของผู้เยาว์และช่วยเหลือในการบังคับใช้นโยบายฉบับนี้โดยการชี้นำให้ผู้เยาว์นั้นไม่ทำการนำส่งข้อมูลส่วนบุคคลเข้ามาในเว็บไซต์
              Consent Wow หรือบริการโดยไม่ได้รับอนุญาต
            </p>
            <p>
              หากท่านมีเหตุผลที่เชื่อได้ว่าได้มีผู้เยาว์ที่อายุต่ำกว่า 20 ปี
              ได้ทำการนำส่งข้อมูลส่วนบุคคลผ่านเว็บไซต์ Consent Wow หรือบริการ
              โปรดติดต่อเรา ท่านจะต้องมีอายุไม่ต่ำไปกว่า 20 ปี
              ในการให้ความยินยอมที่จะประมวลผลข้อมูลส่วนบุคคลของท่านเว้นเสียแต่ว่ากฎหมายที่เกี่ยวข้องได้อนุญาตให้กระทำได้โดยไม่ต้องขอความยินยอม
              (ในบางประเทศ
              เราอาจยินยอมให้ผู้ปกครองของท่านหรือผู้มีอำนาจจัดการแทนโดยชอบด้วยกฎหมายให้กระทำได้ในนามของท่าน)
            </p>
          </>
        ),
      },
      {
        title: 'จดหมายข่าวสาร',
        scrollTo: 'privacy-email-subscription',
        content: (
          <>
            <p>
              เรานำเสนอจดหมายข่าวสารอิเล็กทรอนิกส์ซึ่งท่านสามารถสมัครใจที่จะสมัครได้ตลอดเวลา
              เราให้คำมั่นว่าจะรักษาที่อยู่อีเมลของท่านไว้ให้เป็นความลับและจะไม่ทำการเปิดเผยที่อยู่อีเมลของท่านให้กับบุคคลที่สามเว้นแต่ได้รับอนุญาตเอาไว้ในส่วนของการใช้ข้อมูลและการประมวลผลหรือเพื่อวัตถุประสงค์ในการใช้ผู้ให้บริการบุคคลที่สามในการส่งอีเมลดังกล่าว
              เราจะเก็บรักษาข้อมูลที่ส่งทางอีเมลตามกฎหมายและข้อบังคับที่บังคับใช้
            </p>
            <p>
              อีเมลทั้งหมดที่ส่งจากเราจะระบุอย่างชัดเจนว่าอีเมลนั้นมาจากใครและให้ข้อมูลที่ชัดเจนเกี่ยวกับวิธีการติดต่อผู้ส่ง
              ท่านอาจเลือกที่จะหยุดรับจดหมายข่าวหรืออีเมลการตลาดของเราโดยทำตามคำแนะนำในการยกเลิกการสมัครที่รวมอยู่ในอีเมลเหล่านี้หรือติดต่อเรา
              อย่างไรก็ตาม ท่านจะยังคงได้รับอีเมลเกี่ยวกับธุรกรรมที่จำเป็น
            </p>
          </>
        ),
      },
      {
        title: 'คุกกี้',
        scrollTo: 'privacy-cookies',
        content: (
          <>
            <p>
              เว็บไซต์ Consent Wow ใช้ “คุกกี้”
              เพื่อเพิ่มประสบการณ์การใช้งานของท่านให้สมบูรณ์และมีประสิทธิภาพมากขึ้น
              คุกกี้ คือ
              ไฟล์ข้อความที่เราจัดเก็บไว้ในฮาร์ดไดรฟ์ของท่านโดยเว็บเพจเซิร์ฟเวอร์
              คุกกี้ไม่สามารถใช้เพื่อเปิดโปรแกรมหรือเพื่อนำส่งไวรัสเข้าสู่คอมพิวเตอร์ของท่าน
              คุกกี้ถูกเลือกใช้ให้เป็นเอกลักษณ์แก่ท่านและจะสามารถอ่านได้โดยเว็บเซิร์ฟเวอร์ของโดเมนที่ได้นำคุกกี้มาใช้กับท่าน
            </p>
            <p>
              ข้อมูลที่ถูกรวบรวมโดยอัตโนมัติจะใช้เพื่อระบุการละเมิดที่อาจเกิดขึ้นและสร้างข้อมูลทางสถิติเกี่ยวกับการใช้งานเว็บไซต์
              Consent Wow
              โดยข้อมูลทางสถิตินี้จะไม่ถูกรวบรวมในลักษณะที่ทำให้ระบุผู้ใช้รายใดรายหนึ่งของระบบได้
            </p>
          </>
        ),
      },
      {
        title: 'คุกกี้คืออะไร',
        scrollTo: 'privacy-cookies-definition',
        content: (
          <>
            <p>
              คุกกี้คือไฟล์ข้อมูลขนาดเล็กที่จัดเก็บในรูปแบบไฟล์ข้อความที่ถูกบันทึกเอาไว้ในคอมพิวเตอร์ของท่านหรืออุปกรณ์อื่นเมื่อมีการโหลดหน้าเว็บไซต์ในเบราว์เซอร์
              โดยได้ใช้กันอย่างแพร่หลายในการจดจำท่านและความชอบของท่านไม่ว่าจะเป็นการเข้าชมเพียงครั้งเดียว
              (ผ่าน &quot;คุกกี้เซสชัน&quot;) หรือสำหรับการเข้าชมซ้ำหลายครั้ง
              (โดยใช้ &quot;คุกกี้ถาวร&quot;)
            </p>
            <p>
              คุกกี้เซสชัน
              เป็นคุกกี้ชั่วคราวที่ใช้ระหว่างการเยี่ยมชมเว็บไซต์ของท่านและคุกกี้จะหมดอายุเมื่อท่านปิดเว็บเบราว์เซอร์
            </p>
            <p>
              คุกกี้ถาวรใช้เพื่อจดจำการตั้งค่าของท่านภายในเว็บไซต์ของเราและยังคงอยู่บนคอมพิวเตอร์ตั้งโต๊ะหรืออุปกรณ์มือถือของท่านแม้ว่าท่านจะปิดเบราว์เซอร์หรือรีสตาร์ทคอมพิวเตอร์ของท่านก็ตาม
              คุกกี้เหล่านี้ให้ประสบการณ์ที่สม่ำเสมอและมีประสิทธิภาพสำหรับท่านในขณะที่เยี่ยมชมเว็บไซต์ของเราหรือใช้บริการของเรา
            </p>
            <p>
              คุกกี้อาจมีการตั้งค่าโดยเว็บไซต์
              (&quot;คุกกี้ของบุคคลที่หนึ่ง&quot;)
              หรือโดยบุคคลที่สามเช่นผู้ที่ให้บริการเนื้อหาหรือให้บริการโฆษณาหรือการวิเคราะห์บนเว็บไซต์
              (&quot;คุกกี้ของบุคคลที่สาม&quot;)
              บุคคลที่สามเหล่านี้สามารถจดจำท่านได้เมื่อท่านเยี่ยมชมเว็บไซต์ของเราและเมื่อท่านเยี่ยมชมเว็บไซต์อื่น
              ๆ
            </p>
          </>
        ),
      },
      {
        title: 'คุกกี้ที่เราใช้งาน',
        scrollTo: 'privacy-cookies-list',
        content: (
          <>
            <h3>คุกกี้ที่มีความจำเป็นอย่างยิ่ง (Necessary Cookies)</h3>
            <p>
              คุกกี้ที่มีความจำเป็นอย่างยิ่งช่วยให้เราสามารถนำเสนอประสบการณ์ที่ดีที่สุดเมื่อท่านเข้าถึงและสำรวจเว็บไซต์ของเราและใช้งานคุณสมบัติต่าง
              ๆ ตัวอย่างเช่น
              คุกกี้เหล่านี้แจ้งให้เราทราบว่าท่านได้ทำการสร้างบัญชีและได้ลงชื่อเข้าใช้บัญชีนั้นเพื่อเข้าถึงเนื้อหา,
            </p>
            <h3>คุกกี้เพื่อการทำงานของเว็บไซต์ (Functionality Cookies)</h3>
            <p>
              คุกกี้เพื่อการทำงานของเว็บไซต์ช่วยให้เราดำเนินการเว็บไซต์และบริการของเราตามตัวเลือกที่ท่านเลือก
              ตัวอย่างเช่น
              เราจะจดจำชื่อผู้ใช้งานของท่านและวิธีที่ท่านปรับแต่งเว็บไซต์และบริการสำหรับการเยี่ยมชมครั้งต่อไป
            </p>
            <h3>
              คุกกี้เพื่อการวิเคราะห์/เพื่อประสิทธิภาพ (Analytical Cookies)
            </h3>
            <p>
              คุกกี้เหล่านี้ช่วยให้เราและการบริการของบุคคลที่สามสามารถรวบรวมข้อมูลที่รวบรวมเพื่อวัตถุประสงค์ทางสถิติเกี่ยวกับวิธีที่ผู้เยี่ยมชมของเราใช้งานเว็บไซต์
              คุกกี้เหล่านี้จะไม่มีข้อมูลส่วนบุคคล เช่น ชื่อ และที่อยู่อีเมล
              และจะใช้เพื่อช่วยให้เราปรับปรุงประสบการณ์การใช้งานเว็บไซต์ของท่าน
            </p>
            <h3>คุกกี้โซเชียลมีเดีย (Social Media Cookies)</h3>
            <p>
              คุกกี้ของบุคคลที่สามจากเว็บไซต์สื่อสังคมออนไลน์ (เช่น Facebook,
              Twitter และอื่น ๆ ) เพื่อช่วยให้เราติดตามผู้ใช้สื่อสังคมออนไลน์
              เมื่อพวกเขาเยี่ยมชมเว็บไซต์ของเรา
              โดยใช้เครื่องมือในการติดแท็กที่จัดเตรียมไว้โดยสื่อสังคมออนไลน์เหล่านั้น
              คุกกี้เหล่านี้ยังใช้สำหรับการติดตามเหตุการณ์และเพื่อวัตถุประสงค์ในการการทำโฆษณาออนไลน์
              โดยข้อมูลใด ๆ
              ที่เก็บรวบรวมด้วยเครื่องมือแท็กเหล่านี้จะถูกนำไปใช้ตามนโยบายความเป็นส่วนตัวของเรา
              และเราจะไม่รวบรวมหรือแบ่งปันข้อมูลส่วนบุคคลใด ๆ
              ที่สามารถระบุตัวตนของผู้ใช้ได้ • Google Analytics -
              การสร้างสถิติเกี่ยวกับวิธีที่ผู้เยี่ยมชมใช้เว็บไซต์โดยที่ไม่ระบุตัวตน
              คุกกี้เหล่านี้ใช้เพื่อแยกแยะผู้ใช้
              เราใช้คุกกี้เหล่านี้เพื่อปรับปรุงในแง่ของประสบการณ์ของผู้ใช้บนเว็บไซต์ของเราเท่านั้นและเพื่อทราบว่าเนื้อหาใดของเว็บไซต์ที่ได้รับความสนใจ
              มีการเข้าชมหรือคลิกบ่อยที่สุด (ชื่อ: _gid (หมดอายุใน 24 ชั่วโมง)
              ชื่อ:_ga (หมดอายุใน 2 ปี)) • Hotjar – คุกกี้ที่เก็บ
              ติดตามและวิเคราะห์พฤติกรรมของผู้ใช้งาน
              โดยจะปรากฏออกมาในรูปแบบเฉดสี (Heatmap) (ชื่อ: hjIncludedInSample
              (หมดอายุใน 1 ปี)
            </p>
          </>
        ),
      },
      {
        title:
          'เรามีการใช้เว็บบีคอน (web beacon) หรือพิกเซลการติดตาม (tracking pixel) หรือไม่',
        scrollTo: 'privacy-web-beacon-and-tracking-pixel',
        content: (
          <>
            <p>
              อีเมลของเราอาจมี &quot;เว็บบีคอน&quot; (หรือ
              &quot;พิกเซลการติดตาม&quot;)
              เพื่อแจ้งให้เราทราบว่าอีเมลของเรามีการเปิดและตรวจสอบการคลิกผ่านลิงก์หรือโฆษณาภายในอีเมลหรือไม่
            </p>
            <p>
              เราอาจใช้ข้อมูลนี้เพื่อวัตถุประสงค์รวมถึงการพิจารณาว่าอีเมลใดที่น่าสนใจสำหรับผู้ใช้มากกว่าและเพื่อสอบถามว่าผู้ใช้ที่ไม่เปิดอีเมลของเรามีความประสงค์ที่จะรับอีเมลต่อไปหรือไม่
            </p>
            <p>
              พิกเซลจะถูกลบเมื่อท่านลบอีเมล
              หากท่านไม่ต้องการดาวน์โหลดพิกเซลลงในอุปกรณ์ของท่าน
              ท่านควรอ่านอีเมลในรูปแบบข้อความธรรมดาหรือปิดการแสดงรูปภาพ
            </p>
          </>
        ),
      },
      {
        title: 'ตัวเลือกคุกกี้ของท่านมีอะไรบ้าง',
        scrollTo: 'privacy-cookie-choices',
        content: (
          <>
            <p>
              หากท่านไม่ชอบแนวคิดเกี่ยวกับคุกกี้หรือคุกกี้ในบางประเภท
              ท่านสามารถเปลี่ยนแปลงการตั้งค่าเบราว์เซอร์ของท่านเพื่อลบคุกกี้ที่ตั้งค่าไว้แล้วและไม่ทำการยอมรับคุกกี้ใหม่
              หากต้องการเรียนรู้เพิ่มเติมเกี่ยวกับวิธีการหรือเรียนรู้เพิ่มเติมเกี่ยวกับคุกกี้
              โปรดไปที่ internetcookies.org
            </p>
            <p>
              อย่างไรก็ตาม โปรดทราบว่าหากท่านลบคุกกี้หรือไม่ยอมรับคุกกี้
              ท่านอาจไม่สามารถใช้ระบบการทำงานได้ทั้งหมดของเว็บไซต์ Consent Wow
              และบริการได้
            </p>
          </>
        ),
      },
      {
        title: 'การส่งสัญญาณห้ามติดตาม',
        scrollTo: 'privacy-tracking-rejection',
        content: (
          <p>
            เบราว์เซอร์บางตัวอาจมีคุณสมบัติห้ามติดตาม (Do Not Track)
            ที่ส่งสัญญาณไปยังเว็บไซต์ที่ท่านได้เยี่ยมชมว่าท่านไม่ต้องการให้มีการติดตามกิจกรรมออนไลน์ของท่าน
            การติดตามไม่เหมือนกับการใช้หรือเก็บรวบรวมข้อมูลที่เกี่ยวข้องกับเว็บไซต์
            เพื่อจุดประสงค์เหล่านี้การติดตามหมายถึงการเก็บรวบรวมข้อมูลส่วนบุคคลที่สามารถระบุตัวตนได้จากผู้บริโภคที่ใช้หรือเยี่ยมชมเว็บไซต์หรือบริการออนไลน์ในขณะที่พวกเขาย้ายไปตามเว็บไซต์ต่างๆ
            ในช่วงเวลาหนึ่ง เว็บไซต์ Consent Wow
            ไม่มีการติดตามผู้เยี่ยมชมเมื่อในช่วงเวลาหนึ่งและในเว็บไซต์ของบุคคลที่สาม
            อย่างไรก็ตาม
            เว็บไซต์ของบุคคลที่สามบางแห่งอาจมีการติดตามกิจกรรมการท่องเว็บของท่านเมื่อพวกเขาให้บริการเนื้อหาแก่ท่านซึ่งช่วยให้พวกเขาสามารถปรับแต่งสิ่งที่พวกเขานำเสนอให้แก่ท่านได้
          </p>
        ),
      },
      {
        title: 'เทคโนโลยีติดตามตัวบุคคล (Cookies)',
        scrollTo: 'privacy-cookies',
        content: (
          <>
            <p>
              เพื่อเพิ่มประสบการณ์การใช้งานของคุณให้สมบูรณ์และมีประสิทธิภาพมากขึ้น
              เราใช้เทคโนโลยีติดตามตัวบุคคล(Cookies)หรือเทคโนโลยีที่คล้ายคลึงกัน
              เพื่อพัฒนาการเข้าถึงสินค้าหรือบริการ โฆษณาที่เหมาะสม
              และติดตามการใช้งานของคุณ
              เราใช้คุกกี้เพื่อระบุและติดตามผู้ใช้งานเว็บไซต์และการเข้าถึงเว็บไซต์ของเรา
              หากคุณไม่ต้องการให้มีคุกกี้ไว้ในคอมพิวเตอร์ของคุณ
              คุณสามารถตั้งค่าบราวเซอร์เพื่อปฏิเสธคุกกี้ก่อนที่จะใช้เว็บไซต์ของเราได้
            </p>
          </>
        ),
      },
      {
        title: 'การเชื่อมต่อไปยังเว็บไซต์อื่น',
        scrollTo: 'terms-links-to-other-websites',
        content: (
          <p>
            เว็บไซต์ Consent Wow
            มีลิงก์ที่เชื่อมต่อไปยังเว็บไซต์อื่นที่ไม่ได้เป็นเจ้าของหรือควบคุมโดยเรา
            โปรดทราบว่าเราจะไม่รับผิดชอบต่อแนวทางการปฏิบัติทางด้านความเป็นส่วนตัวของเว็บไซต์อื่น
            ๆ หรือบุคคลที่สามดังกล่าว ดังนั้น
            เราขอแนะนำให้ท่านได้ตระหนักเมื่อท่านได้ออกจากเว็บไซต์ของเราและอ่านนโยบายความเป็นส่วนตัวของแต่ละเว็บไซต์ที่อาจมีการเก็บรวบรวมข้อมูลส่วนบุคคล
          </p>
        ),
      },
      {
        title: 'การรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคล',
        scrollTo: 'privacy-information-security',
        content: (
          <p>
            เรารักษาความปลอดภัยข้อมูลที่ท่านให้ไว้บนเซิร์ฟเวอร์คอมพิวเตอร์ภายใต้การควบคุม
            สภาพแวดล้อมที่ปลอดภัย
            ได้รับการปกป้องจากการเข้าถึงการใช้งานหรือการเปิดเผยโดยไม่ได้รับอนุญาต
            เรารักษามาตรการป้องกันด้านการบริหารเทคนิคและทางกายภาพที่สมเหตุสมผลเพื่อป้องกันการเข้าถึง
            การใช้ การแก้ไข
            และการเปิดเผยข้อมูลส่วนบุคคลโดยไม่ได้รับอนุญาตที่อยู่ภายใต้การควบคุมและดูแล
            อย่างไรก็ตาม
            เราไม่สามารถรับประกันการส่งข้อมูลผ่านอินเทอร์เน็ตหรือเครือข่ายไร้สายได้
            ดังนั้น ในขณะที่เราพยายามปกป้องข้อมูลส่วนบุคคลของท่าน ท่านรับทราบว่า
            (1)
            มีข้อจำกัดด้านความปลอดภัยและความเป็นส่วนตัวของอินเทอร์เน็ตซึ่งอยู่นอกเหนือการควบคุมของเรา
            (2) ความปลอดภัย ความสมบูรณ์ และความเป็นส่วนตัวของข้อมูลใด ๆ
            และข้อมูลทั้งหมดที่แลกเปลี่ยนระหว่างท่านและเว็บไซต์ของเราจะไม่สามารถรับประกันได้
            และ (3)
            ข้อมูลและข้อมูลดังกล่าวอาจถูกดูหรือถูกดัดแปลงโดยบุคคลที่สามในระหว่างการถ่ายโอนแม้ว่าจะได้พยายามอย่างเต็มที่แล้วก็ตาม
          </p>
        ),
      },
      {
        title: 'การรั่วไหลของข้อมูล',
        scrollTo: 'privacy-data-breach',
        content: (
          <p>
            ในกรณีที่เราตรวจพบว่าความปลอดภัยของเว็บไซต์ Consent Wow
            ได้ถูกบุกรุกหรือข้อมูลส่วนบุคคลของผู้ใช้ถูกเปิดเผยต่อบุคคลที่สามที่ไม่เกี่ยวข้องอันเป็นผลมาจากกิจกรรมภายนอก
            ซึ่งรวมถึงแต่ไม่จำกัดเพียง การโจมตีด้านความปลอดภัยหรือการฉ้อโกง
            เราขอสงวนสิทธิในการใช้มาตรการที่เหมาะสม ซึ่งรวมถึงแต่ไม่จำกัดเพียง
            การสอบสวนและการรายงานตลอดจนการแจ้งเตือนและให้ความร่วมมือกับหน่วยงานที่บังคับใช้กฎหมาย
            ภายใน 72 ชั่วโมงนับตั้งแต่ทราบถึงการรั่วไหลของข้อมูล
            ในกรณีที่มีการรั่วไหลของข้อมูล
            เราจะใช้ความพยายามตามความเหมาะสมในการแจ้งเตือนบุคคลที่ได้รับผลกระทบหากเราเชื่อว่ามีอาจมีความเสี่ยงตามสมควรที่จะเกิดอันตรายต่อผู้ใช้อันเป็นผลมาจากการรั่วไหลหรือหากกฎหมายกำหนดให้ต้องแจ้งให้ทราบ
            เมื่อเราทำเสร็จสิ้นแล้วเราจะโพสต์ประกาศบนเว็บไซต์ Consent Wow
            ส่งอีเมลถึงท่าน
          </p>
        ),
      },
      {
        title: 'การเปิดเผยตามกฎหมาย',
        scrollTo: 'privacy-information-disclosure',
        content: (
          <p>
            เราจะทำการเปิดเผยข้อมูลส่วนบุคคลใด ๆ ที่เราเก็บรวบรวม ใช้
            หรือได้รับหากกฎหมายได้มีการกำหนดหรืออนุญาต เช่น
            เพื่อปฏิบัติตามหมายศาลหรือกระบวนการทางกฎหมายที่คล้ายกัน
            และเมื่อเราเชื่อโดยสุจริตใจว่าการเปิดเผยข้อมูลเป็นสิ่งที่จำเป็นเพื่อปกป้องสิทธิ์ของเรา
            ปกป้องความปลอดภัยของท่านหรือผู้อื่น การตรวจสอบการฉ้อฉล
            หรือตอบสนองต่อคำขอของรัฐบาล
            ในกรณีที่เราดำเนินการเปลี่ยนแปลงทางธุรกิจ เช่น
            การควบรวมกิจการหรือการเข้าซื้อกิจการโดยบริษัทอื่น
            หรือการขายทรัพย์สินทั้งหมดหรือบางส่วน
            บัญชีผู้ใช้ของท่านและข้อมูลส่วนบุคคลอาจถูกรวมอยู่ในทรัพย์สินที่ได้โอนย้ายไป
          </p>
        ),
      },
      {
        title: 'การแก้ไขเปลี่ยนแปลงนโยบายความเป็นส่วนตัว',
        scrollTo: 'privacy-changes-and-amendments',
        content: (
          <p>
            เราอาจเปลี่ยนแปลงนโยบายนี้เป็นครั้งคราวตามดุลยพินิจของเราและจะแจ้งให้ท่านทราบถึงการเปลี่ยนแปลงที่สำคัญใด
            ๆ ต่อวิธีการที่เราปฏิบัติต่อข้อมูลส่วนบุคคล
            เมื่อมีการเปลี่ยนแปลงเราจะแก้ไขวันที่ทำให้เป็นปัจจุบันไว้ที่ด้านล่างของหน้านี้
            เราอาจมีการแจ้งให้ท่านทราบด้วยวิธีอื่น ๆ ตามดุลยพินิจของเรา เช่น
            ข้อมูลติดต่อที่ท่านให้ไว้ นโยบายฉบับที่มีการเปลี่ยนแปลงใด ๆ
            จะมีผลทันทีเมื่อมีการประกาศนโยบายฉบับแก้ไข
            เว้นแต่จะระบุไว้เป็นอย่างอื่น
            การใช้เว็บไซต์หรือบริการของท่านที่ดำเนินต่อไปภายหลังหลังจากวันที่นโยบายฉบับแก้ไขมีผลบังคับใช้
            (หรือการกระทำอื่น ๆ ที่ระบุไว้ในขณะนั้น)
            จะถือว่าท่านให้ความยินยอมต่อการเปลี่ยนแปลงเหล่านั้น อย่างไรก็ตาม
            เราจะไม่ใช้ข้อมูลส่วนบุคคลของท่านในลักษณะที่แตกต่างจากที่ระบุไว้ในขณะที่ได้เก็บรวบรวมข้อมูลส่วนบุคคลของท่านโดยไม่ได้รับความยินยอมจากท่าน
          </p>
        ),
      },
      {
        title: 'รายละเอียดการติดต่อ',
        scrollTo: 'privacy-contacting-us',
        content: ContactingUs,
      },
    ],
  },
}
